module.exports = [{
      plugin: require('Y:/bidcentral/landing-page/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('Y:/bidcentral/landing-page/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-68088393-2","head":false},
    },{
      plugin: require('Y:/bidcentral/landing-page/node_modules/gatsby-plugin-hubspot/gatsby-browser'),
      options: {"plugins":[],"trackingCode":"4679706","respectDNT":true},
    },{
      plugin: require('Y:/bidcentral/landing-page/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
